module.exports = __webpack_public_path__ + "img/xmasParty3.41b81765.jpg";